import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';

@Injectable()
export class CustomPaginatorIntl extends MatPaginatorIntl {
  override changes = new Subject<void>();

  constructor(private translateService: TranslateService) {
    super();
    this.translateService.onLangChange.subscribe(() => this.updateLabels());
    this.updateLabels();
  }

  private updateLabels(): void {
    this.itemsPerPageLabel = this.translateService.instant('paginator.items_per_page');
    this.nextPageLabel = this.translateService.instant('paginator.next_page');
    this.previousPageLabel = this.translateService.instant('paginator.previous_page');
    this.firstPageLabel = this.translateService.instant('paginator.first_page');
    this.lastPageLabel = this.translateService.instant('paginator.last_page');
    this.changes.next();
  }

  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return this.translateService.instant('paginator.range_page_zero', { length });
    }
    const amountPages = Math.ceil(length / pageSize);
    return this.translateService.instant('paginator.range_page', {
      page: page + 1,
      amountPages,
    });
  };
}
